import { useTranslation } from "react-i18next";

export const GuestDetails = (props) => {
  const { booking, branding } = props;
  const { t } = useTranslation();
  return (
    <div className="wrapper">
      <div
        className="padding-10"
        style={{
          backgroundColor: branding.headingColor,
          color: "#fff",
          fontSize: "16px",
          fontWeight: "bold",
          fontFamily: branding.headingFont,
        }}
      >
        {t("guest_information.title")}
      </div>
      <table className="table-wrapper">
        <tbody>
          <tr>
            <th className="custom-guest-details">
              {t("guest_information.guest_name")}
            </th>
            <td
              className="custom-guest-details"
              style={{
                fontWeight: "bold",
              }}
            >
              {booking.guestName}
            </td>
          </tr>
          <tr>
            <th className="custom-guest-details">
              {t("guest_information.email")}
            </th>
            <td className="custom-guest-details">{booking.guestEmail}</td>
          </tr>
          <tr>
            <th className="custom-guest-details">
              {t("guest_information.phone_number")}
            </th>
            <td className="custom-guest-details">{booking.guestPhoneNumber}</td>
          </tr>
          <tr>
            <th className="custom-guest-details">
              {t("guest_information.nationality")}
            </th>
            <td className="custom-guest-details">{booking.guestNationality}</td>
          </tr>
          <tr>
            <th className="padding-10">
              {t("guest_information.special_requests")}
            </th>
            <td className="padding-10">{booking.specialRequest || "None"}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
